import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLikesComponent } from './pages/my-likes/my-likes.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [MyLikesComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    FlexModule,
    RouterModule,
    FormsModule
  ],
  exports: [MyLikesComponent]
})
export class LikesModule {}
